import { apiRequest } from '@/api/helpers/apiRequest';
import type { SoftDeleteCharacterResponse } from 'schemas';
import { SoftDeleteCharacterResponseSchema } from 'schemas';

/**
 * Soft deletes a character by ID.
 * @param characterId - The UUID of the character to delete
 * @returns Promise that resolves when the character is successfully deleted
 */
export const softDeleteCharacter = async (
  characterId: string
): Promise<{ message: string; deletedCharacterId: string }> => {
  return await apiRequest<
    { message: string; deletedCharacterId: string },
    SoftDeleteCharacterResponse
  >(
    'PUT',
    `/api/characters/${characterId}/delete`,
    {},
    SoftDeleteCharacterResponseSchema
  );
};
